import { FC, ReactNode } from "react";
import {
    Collapse as AntCollapse,
    CollapseProps as AntCollapseProps,
    CollapsePanelProps as AntCollapsePanelProps,
    Row,
    Col,
} from "antd";
import { clsx } from "clsx";
import { SvgIcon } from "../../../common/components/SvgIcon";
import classes from "./Collapse.module.less";

const { Panel: AntPanel } = AntCollapse;

export interface CollapsePanelProps extends Omit<AntCollapsePanelProps, "header"> {
    title?: string;
    description?: string;
    header?: ReactNode;
}

const Panel: FC<CollapsePanelProps> = ({ title, description, className, header, ...props }) => {
    return (
        <AntPanel
            {...props}
            header={
                header || (
                    <Row>
                        <Col flex={1}>
                            {title && <div className={classes.headerTitle}>{title}</div>}
                            {description && <div>{description}</div>}
                        </Col>
                    </Row>
                )
            }
            className={clsx(classes.panel, className)}
        />
    );
};

export interface CollapseProps extends AntCollapseProps {}

export const Collapse: FC<CollapseProps> & {
    Panel: typeof Panel;
} = ({ className, ...restProps }) => {
    return (
        <AntCollapse
            bordered={false}
            collapsible="header"
            expandIcon={() => <SvgIcon name="down" size={20} className={classes.expandIcon} />}
            expandIconPosition="end"
            {...restProps}
            className={clsx(classes.collapse, className)}
        />
    );
};

Collapse.Panel = Panel;
Collapse.displayName = "Collapse";
Panel.displayName = "Collapse.Panel";
